var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAltArrowDown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95388 7.6746C5.13359 7.46494 5.44924 7.44066 5.6589 7.62037L10.0002 11.3415L14.3414 7.62037C14.5511 7.44066 14.8668 7.46494 15.0465 7.6746C15.2262 7.88427 15.2019 8.19992 14.9922 8.37963L10.3256 12.3796C10.1383 12.5401 9.86202 12.5401 9.67478 12.3796L5.00811 8.37963C4.79845 8.19992 4.77417 7.88427 4.95388 7.6746Z",
    fill: "#1BB92C"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAltArrowDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/AltArrowDown.833c798d.svg";
export { ForwardRef as ReactComponent };